import { Globals } from "../../global/Globals";
import React from "react";
import "./Loader.css";

const Loader = (props) => {
  return (
    <div className={`mch-loader ${props.component ? 'loader_middle' :""}`}>
      <img width={props.width} height={props.height} src={Globals.LOADERS.SPINNING_LOADER} className="loader_img" />
    </div>
  )
};

export default Loader
